import { TTrackingData } from './types';

import axiosInstance from 'common/services/common/instance';

export const getTrackingService = async (params?: BaseFilterParams):
  Promise<APIPaginationResponse<TTrackingData[]>> => {
  const res = await axiosInstance.get('survey/trackings', { params });
  return res.data;
};

export const exportTrackingService = async (params?: BaseFilterParams):
  Promise<{ data: { link: string } }> => {
  const res = await axiosInstance.get('survey/trackings/export', { params });
  return res.data;
};
